import { Duration as u } from "./date.js";
class o {
  static DEFAULT_CONCURRENCY = 10;
  static *#s() {
    let t = 0;
    for (; ; )
      yield t, t++;
  }
  /** @type {Generator<number>} */
  #n;
  /** @type {Task[]} */
  #i;
  /** @type {Task[]} */
  #t;
  /**
    * @param {Object} options
    * @param {number=} options.concurrency
    */
  constructor(t = {}) {
    this.concurrency = t.concurrency ?? o.DEFAULT_CONCURRENCY, this.#i = [], this.#t = [], this.#n = o.#s();
  }
  /** @returns {number} */
  #h() {
    return this.#n.next().value;
  }
  /**
    * @template [T = any]
    * @param {() => Promise<T>} fn
    * @returns {Promise<T>}
    */
  run(t) {
    return new Promise((i, n) => {
      let r = { id: this.#h(), fn: t, resolve: i, reject: n };
      this.#t.length < this.concurrency && this.#i.length === 0 ? this.#r(r) : (this.#i.push(r), this.#e());
    });
  }
  #e() {
    let t = Math.min(
      this.#i.length,
      this.concurrency - this.#t.length
    );
    if (t !== 0)
      for (let i = 0; i < t; i++) {
        let n = this.#i.shift();
        this.#r(n);
      }
  }
  /** @param {Task=} task */
  #r(t) {
    t != null && (this.#t.push(t), t.fn().then(t.resolve).catch(t.reject).finally(() => {
      this.#t.splice(this.#t.indexOf(t), 1), this.#e();
    }));
  }
}
const f = 5 * u.SECONDS_PER_MINUTE * u.MILLISECONDS_PER_SECOND;
function N(l, { maxBackoffDelay: t = f, maxRetries: i = 30, stopOnAbort: n = !1 } = {}) {
  return new Promise((r, s) => {
    let h = 0;
    function c() {
      l().then(r).catch((e) => {
        if (n && e.name === "AbortError") {
          s(e);
          return;
        }
        if (e?.retryable === !1) {
          s(e);
          return;
        }
        if (h >= i) {
          s(e);
          return;
        }
        const a = Math.min(
          2 ** h * u.MILLISECONDS_PER_SECOND + Math.random(),
          t
        );
        setTimeout(c, a), h++;
      });
    }
    c();
  });
}
export {
  o as AsyncTaskQueue,
  N as exponentialBackoff
};
